import {ReactComponent as IconMarketDown} from '#/components/icons/ico-market-down.svg';
import {ReactComponent as IconMarketUp} from '#/components/icons/ico-market-up.svg';
import {MinusIcon} from '@heroicons/react/24/outline';
import {FunctionComponent} from 'react';

type MarketIndicatorIconProps = {
  direction: 'up' | 'down' | 'stable';
  size: 'xs' | 'sm';
  className?: string;
};

const iconSizeClassName: Record<MarketIndicatorIconProps['size'], string> = {
  xs: 'w-2.5 h-2.5',
  sm: 'w-3 h-3',
};

export const MarketIndicatorIcon: FunctionComponent<MarketIndicatorIconProps> = ({className = '', size, direction}) => {
  switch (direction) {
    case 'up':
      return <IconMarketUp className={`${iconSizeClassName[size]} ${className}`} />;
    case 'down':
      return <IconMarketDown className={`${iconSizeClassName[size]} ${className}`} />;
    case 'stable':
      return (
        <MinusIcon
          className={`${iconSizeClassName[size]} aspect-square stroke-gray-400 fill-gray-400 stroke-[3] ${className}`}
        />
      );
  }
};
